import {
  createPlugin,
  createRoutableExtension,
  createComponentExtension,
} from '@backstage/core-plugin-api';
import { rootRouteRef } from './routes';

export const stackPoliciesPlugin = createPlugin({
  id: 'stack-policies',
  routes: {
    root: rootRouteRef,
  },
});

export const StackPoliciesPage = stackPoliciesPlugin.provide(
  createRoutableExtension({
    name: 'StackPoliciesPage',
    component: () =>
      import('./components/StackPoliciesPage').then(m => m.StackPoliciesPage),
    mountPoint: rootRouteRef,
  }),
);

export const EntityStackPoliciesCard = stackPoliciesPlugin.provide(
  createComponentExtension({
    name: 'EntityStackPoliciesCard',
    component: {
      lazy: () =>
        import('./components/EntityStackPoliciesCard').then(
          m => m.EntityStackPoliciesCard,
        ),
    },
  }),
);
